import * as localForage from 'localforage'
import UniversalStorage from '@vue-storefront/core/store/lib/storage'

export function beforeRegistration({ Vue, config, store, isServer }) {
  Vue.prototype.$db.storedCardsCollection = new UniversalStorage(localForage.createInstance({
    name: 'storedCards',
    storeName: 'storedCards',
    driver: localForage['LOCALSTORAGE']
  }))
}
